import { getStore as getStoreReduxLegacy } from 'redux/stores/app.store';

import type { Dispatch } from 'redux';

export function dispatchReduxAction<TDispatch = Dispatch<any>>(
  action: TDispatch,
) {
  return getStoreReduxLegacy().dispatch(action);
}

export const dpReduxAction = dispatchReduxAction;
